<script lang="ts">
    
    import 'swiper/css';
    import { onMount } from 'svelte';
    import { Swiper, SwiperSlide } from 'swiper/svelte';
    import type { GalleryActivity } from "../../Model/GalleryActivity";
    import ActiviyModal from "../Shared/ActiviyModal.svelte";

    export let activity: GalleryActivity;

    let galleryHeight = 400;

    onMount(() => {
        activity.setCompleted();
    });

</script>

<ActiviyModal on:close title={activity.title}>
    <div class="gallery-container" bind:clientHeight={galleryHeight} style="--galleryHeight: {galleryHeight}px;">
        <Swiper>
            {#each activity.gallery as { image }}
                <SwiperSlide>
                    <div class="gallery-slide">
                        <img src={image} alt="">
                    </div>
                </SwiperSlide>
            {/each}
        </Swiper>
    </div>
</ActiviyModal>

<style lang="scss">

    .gallery-container {
        height: 100%;
        background-color: #222;
    }

    .gallery-slide {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: var(--galleryHeight, 400px);
    }

</style>
